import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../api/client';
import { track } from '../analytics/track';
import { forgetReferral, inviteFromSearch, pendingInvite, pendingReferral, referralFromSearch, rememberInvite, rememberReferral } from './referral';

/**
 * Tells the API, once, which shared video (or whose invite link) a new account came from. Mounted for
 * the whole app: the link lands on /ai-agent, but a redirect that loses its
 * query can land anywhere, and the stash (growth/referral.js) covers that.
 */
export default function ReferralClaim() {
  const { isAuthenticated } = useAuth();
  const { search } = useLocation();
  const asked = useRef(false);

  useEffect(() => {
    const fromLink = referralFromSearch(search);
    if (fromLink) rememberReferral(fromLink);
    const invitedBy = inviteFromSearch(search);
    if (invitedBy) rememberInvite(invitedBy);
    if (!isAuthenticated || asked.current) return;
    const projectId = pendingReferral();
    const inviterId = projectId ? null : pendingInvite();
    if (!projectId && !inviterId) return;
    asked.current = true;
    (projectId ? api.claimReferral(projectId) : api.claimInvite(inviterId))
      .then((result) => {
        // Accepted or refused, the API has answered: asking again changes nothing
        forgetReferral();
        track(result?.accepted ? 'referral_claim_accepted' : 'referral_claim_not_accepted', { reason: result?.reason, via: projectId ? 'video' : 'invite' });
      })
      .catch(() => {
        // The network, or the API mid-deploy: keep it and ask on the next load
        asked.current = false;
      });
  }, [isAuthenticated, search]);

  return null;
}
